/**
 * @generated SignedSource<<a28fe62f8777a3bef3b3ed11ca2f4a63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportSageIntacctDepartmentsInput = {
  sageIntacctDepartmentIds?: ReadonlyArray<number | null> | null;
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ImportSageIntacctDepartmentsMutation$variables = {
  input: ImportSageIntacctDepartmentsInput;
};
export type ImportSageIntacctDepartmentsMutation$data = {
  readonly importSageIntacctDepartments: {
    readonly departments: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly sageIntacctId: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type ImportSageIntacctDepartmentsMutation = {
  variables: ImportSageIntacctDepartmentsMutation$variables;
  response: ImportSageIntacctDepartmentsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctDepartmentsPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctDepartments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DepartmentTypeEdge",
        "kind": "LinkedField",
        "name": "departments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartmentType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1f811c10b1461aa862ff60f6b956bc2",
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctDepartmentsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctDepartmentsMutation(\n  $input: ImportSageIntacctDepartmentsInput!\n) {\n  importSageIntacctDepartments(input: $input) {\n    departments {\n      node {\n        id\n        name\n        sageIntacctId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0505f0cdfb914c50ed20cb9b85e0d683";

export default node;
